import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faHeart } from '@fortawesome/free-solid-svg-icons';
import { sxModal, sxRegular, sxButtonVoltar, sxModalTitle, sxCheckbox } from './sxProps';
import './styles.css'
import { Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { BoasVindasModalProps } from '../../interfaces/props/BoasVindasModalProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { sxCheckboxContrast } from '../../assets/styles/CommonSxProps';
import { useState } from 'react';
import { aceiteNaoMostrarNovamente } from '../../services/SaudeBemEstar/SaudeEmocionalService';


function BoasVindasModal(props: BoasVindasModalProps) {
  const accessibility = useAccessibility();
  const [checked, setChecked] = useState<boolean>(false);

  const handleDontShow = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleBack = async () => {
    const acceptTerms = props.acceptTerms
    if (acceptTerms !== null && checked) {
      await aceiteNaoMostrarNovamente(acceptTerms.idTermoResponsabilidade, acceptTerms.idOperador)
    }
    props.onCloseModal()
  }

  return (
    <Modal
      open={props.open}
      onClose={props.onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={sxModal} tabIndex={0} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }} >
        <button className='boas-vindas-modal-header-close' onClick={handleBack}><FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} /></button>
        <div className="boas-vindas-modal-content">
          <FontAwesomeIcon icon={faHeart} size='3x' color='#00995D' style={accessibility.contrastColorAccessibility} />
          <Typography style={accessibility.calculateTextStyle(28)} sx={sxModalTitle}>Bem-vindo(a) ao novo Canal do Cliente!</Typography>
          <div>
            <Typography style={accessibility.textStyleAccessibilityWithMargin} sx={{ ...sxRegular, textAlign: 'center' }}>Estamos desenvolvendo um ambiente moderno e atrativo e sua opinião é muito importante para nós.</Typography>
            <Typography style={accessibility.textStyleAccessibilityWithMargin} sx={{ ...sxRegular, textAlign: 'center' }}>Em breve, você poderá acessar nossa pesquisa de satisfação no menu lateral, em “Minha Opinião”, e descrever como foi sua experiência e como podemos melhorar ainda mais.</Typography>
            <Typography style={accessibility.textStyleAccessibilityWithMargin} sx={{ ...sxRegular, textAlign: 'center' }}>Ah! Algumas funcionalidades ainda não estão disponíveis e serão liberadas gradualmente, então, alguns serviços poderão ser redirecionadas para o antigo formato.</Typography>
            <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxRegular, textAlign: 'center' }}>Agradecemos a sua compreensão.</Typography>
          </div>
          <div className='flex-row'>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleDontShow}
                  style={accessibility.contrastColorAccessibility} />
              }
              label="Não exibir esta mensagem novamente"
              sx={accessibility.contrastMode ? sxCheckboxContrast : sxCheckbox} />
          </div>
          <Button variant='contained' sx={sxButtonVoltar}
            onClick={handleBack}
            style={accessibility.buttonStyleAccessibility}
          >
            <Typography style={accessibility.buttonTextStyleAccessibility}>Ir para o início</Typography>
          </Button>

        </div>

      </Box>
    </Modal>
  );
}

export default BoasVindasModal;